import React from 'react';

const css = `
.bg-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: -1;
}

/* Gold dots — soft pool, upper-left quadrant */
.bg-layer::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255, 215, 0, 0.2) 1.5px, transparent 1.5px);
  background-size: 28px 28px;
  mask-image: radial-gradient(ellipse at 25% 35%, black 0%, transparent 60%);
  -webkit-mask-image: radial-gradient(ellipse at 25% 35%, black 0%, transparent 60%);
}

/* Blue dots — soft pool, lower-right quadrant */
.bg-layer::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(100, 130, 255, 0.24) 1.5px, transparent 1.5px);
  background-size: 28px 28px;
  mask-image: radial-gradient(ellipse at 75% 65%, black 0%, transparent 60%);
  -webkit-mask-image: radial-gradient(ellipse at 75% 65%, black 0%, transparent 60%);
}
`;

export default function BackgroundEffects() {
  return (
    <>
      <style>{css}</style>
      <div className="bg-layer" aria-hidden="true" />
    </>
  );
}
